import axios, { AxiosRequestConfig } from "axios";
import showMessage from "../components/NotistackPlus";
import {
  RIMS_COOKIE_STG_CONSTANTS,
  RIMS_LOCAL_STG_CONSTANTS,
} from "../constants";
import cookie from "react-cookies";
import i18n from "i18next";
import { logoutFunction } from "../common/utils";
import { useConfigStore } from "../store/config";

// const isPrd = process.env.NODE_ENV === 'production';

//export const basicUrl = isPrd ? 'https://88xqd6km6b.execute-api.us-east-1.amazonaws.com' : 'http://localhost:3000/api'

export const basicUrl = process.env.REACT_APP_API_GETWAY;
export const adminCenterBasicUrl =
  process.env.REACT_APP_API_GETWAY_ADMIN_CENTER;

export const dossierBuilder =
  "https://dossierbuilderapi.devsecops.freyafusion.com";
// export const dossierBuilderDev = 'https://n1olv5l2fg.execute-api.us-east-1.amazonaws.com/v1'
const refreshURL = "/common-auth/refresh";

const service = axios.create({
  baseURL: basicUrl,
});

service.interceptors.request.use(
  (config) => {
    const language = useConfigStore.getState()?.language;
    console.log("service.interceptors.request", language);
    const languageformat = language === "en" ? "" : language;
    let token = cookie.load(RIMS_COOKIE_STG_CONSTANTS.LOGIN_TOKEN);
    // config.withCredentials = true;
    token
      ? (config.headers = {
          "Content-Type":
            config.responseType === "arraybuffer" &&
            JSON.stringify(config.data) === "{}"
              ? "application/octet-stream;charset=utf-8"
              : "application/json;charset=utf-8",
          Authorization: `Bearer ${token}`,
          "Accept-Language": languageformat || "",
        })
      : (config.headers = {
          "Content-Type": "application/json;charset=utf-8",
        });
    // config.data = QS.stringify(config.data)
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response: any) => {
    if (response.config.responseType !== "arraybuffer") {
      if (response.status) {
        switch (response.status) {
          case 200:
            return response.data;
          case 400:
          case 401:
          case 403:
            if (response.config?.url?.indexOf(refreshURL) > -1) {
              logoutFunction();
              window.location.href = window.location.origin;
              console.log(
                "I catch err refreshURL 401/400/403 in request. will return"
              );
            }
            return;
          // case 500:

          // break;
          default:
            console.log("error", response.data.msg);
        }
      }
    } else {
      return response;
    }
  },
  (err) => {
    console.log("err", err);

    if (err.config?.url?.indexOf(refreshURL) > -1) {
      logoutFunction();
      console.log("I catch err refreshURL 401. will return");
      window.location.href = window.location.origin;
      return;
    } else {
      switch (err.response.status) {
        case 401:
          console.log("I catch err 401. will return");
          break;
        case 403:
          break;
        // case 500:
        //   if (localStorage.getItem(RIMS_LOCAL_STG_CONSTANTS.LOGIN_TOKEN)) {
        //     SnackbarUtils.error(
        //       "There is something wrong with server, please try again later"
        //     );
        //   }
        //   break;
        default:
          const currentErrorCode = err?.response?.data?.code;
          let currentMsg = err?.response?.data?.message;
          const ignoreErrorCodes  = [1111,2017,1112];
          if (ignoreErrorCodes.includes(currentErrorCode)) {
            console.error(err?.response?.data?.message);
            break;
          } else {
            if (!currentMsg) {
              currentMsg = i18n.t("common.tip.commonError");
              if (typeof err?.data?.msg === "string") {
                currentMsg = err?.data?.msg;
              } else if (typeof err.message === "string") {
                currentMsg = err.message;
              }
              const msgKeys = ["network.error"];
              let currentMsgKey = currentMsg
                .toLocaleLowerCase()
                .replace(/\s/gi, ".");
              if (msgKeys.includes(currentMsgKey)) {
                currentMsg = i18n.t(currentMsgKey);
              }
            }
            showMessage.error(currentMsg);
          }
          break;
      }
    }
    return Promise.reject(err);
  }
);

// const refreshAuthLogic = (failedRequest: any) => {
//   const userInfoJson: any = window.localStorage.getItem(
//     RIMS_LOCAL_STG_CONSTANTS.USER_INFO
//   );
//   const userInfo: any =
//     typeof userInfoJson === "string" ? JSON.parse(userInfoJson) : null;
//   return service
//     .post(refreshURL, {
//       username: userInfo?.username,
//       refreshToken: userInfo?.refreshToken,
//     })
//     .then((response: any) => {
//       console.log("refreshURL response is", response);
//       if (!response) {
//         // logoutFunction();
//         // window.location.href = window.location.origin;
//         return Promise.reject();
//       } else {
//         window.localStorage.setItem(
//           RIMS_LOCAL_STG_CONSTANTS.LOGIN_TOKEN,
//           response.data.accessToken
//         );
//         window.localStorage.setItem(
//           RIMS_LOCAL_STG_CONSTANTS.USER_INFO,
//           JSON.stringify(response.data)
//         );
//         failedRequest.response.config.headers["Authorization"] =
//           "Bearer " + response.data.accessToken;
//       }
//       return Promise.resolve();
//     })
//     .catch((error: any) => {
//       // logoutFunction();
//       // window.location.href = window.location.origin;
//       console.log("I catch err in refreshURL. will return");
//       return;
//     });
// };

export default service;

export const dossierBuilderService = axios.create({
  baseURL: dossierBuilder,
});

dossierBuilderService.interceptors.request.use(
  (config) => {
    const language = useConfigStore.getState()?.language;
    const languageformat = language === "en" ? "" : language;
    let userEmail: any = cookie.load(RIMS_COOKIE_STG_CONSTANTS.USER_EMAIL);
    let tenantId = cookie.load(RIMS_COOKIE_STG_CONSTANTS.USER_TENANT_ID);
    let token = cookie.load(RIMS_COOKIE_STG_CONSTANTS.LOGIN_TOKEN);
    // config.withCredentials = true;
    token
      ? (config.headers = {
          "Content-Type":
            config.responseType === "arraybuffer" &&
            JSON.stringify(config.data) === "{}"
              ? "application/octet-stream;charset=utf-8"
              : "application/json;charset=utf-8",
          Authorization: `Bearer ${token}`,
          "Accept-Language": languageformat || "",
          "tenant-id": tenantId || "",
          "user-id": userEmail,
        })
      : (config.headers = {
          "Content-Type": "application/json;charset=utf-8",
          "tenant-id": tenantId || "",
          "user-id": userEmail,
        });
    // config.data = QS.stringify(config.data)
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

dossierBuilderService.interceptors.response.use(
  (response: any) => {
    if (response.config.responseType !== "arraybuffer") {
      if (response.status) {
        switch (response.status) {
          case 200:
            return response.data;
          case 400:
          case 401:
          case 403:
            if (response.config?.url?.indexOf(refreshURL) > -1) {
              // logoutFunction();
              // window.location.href = window.location.origin;
              console.log(
                "I catch err refreshURL 401/400/403 in request. will return"
              );
            }
            return;
          default:
            console.log("error", response.data.msg);
        }
      }
    } else {
      return response;
    }
  },
  (err) => {
    if (err.config?.url?.indexOf(refreshURL) > -1) {
      // logoutFunction();
      // console.log("I catch err refreshURL 401. will return");
      // window.location.href = window.location.origin;
      return;
    } else {
      switch (err.response.status) {
        case 401:
          console.log("I catch err 401. will return");
          break;
        case 403:
          break;
        case 500:
          if (localStorage.getItem(RIMS_LOCAL_STG_CONSTANTS.LOGIN_TOKEN)) {
            showMessage.error(
              "There is something wrong with server, please try again later"
            );
          }
          break;
        default:
        // SnackbarUtils.error('There is something wrong with server, please try again later')
      }
    }
    return Promise.reject(err);
  }
);

// -----------------
export type GlobalSearchAxiosRequestConfigType = AxiosRequestConfig<any> & {
  moduleName?: string;
};
const globalSearchBasicUrl = process.env.REACT_APP_SEARCH_API_GETWAY;

export const globalSearchService = axios.create({
  baseURL: globalSearchBasicUrl,
});

globalSearchService.interceptors.request.use(
  (config: GlobalSearchAxiosRequestConfigType) => {
    const language = useConfigStore.getState()?.language;
    const languageformat = language === "en" ? "" : language;
    const domainName = cookie.load(RIMS_COOKIE_STG_CONSTANTS.DOMAIN);
    const tenantId = cookie.load(RIMS_COOKIE_STG_CONSTANTS.USER_TENANT_ID);
    let token = cookie.load(RIMS_COOKIE_STG_CONSTANTS.LOGIN_TOKEN);
    token
      ? (config.headers = {
          "Content-Type":
            config.responseType === "arraybuffer" &&
            JSON.stringify(config.data) === "{}"
              ? "application/octet-stream;charset=utf-8"
              : "application/json;charset=utf-8",
          Authorization: `Bearer ${token}`,
          "Accept-Language": languageformat || "",
          "domain-name": domainName,
          "tenant-id": tenantId,
          "module-name": config.moduleName ?? "",
        })
      : (config.headers = {
          "Content-Type": "application/json;charset=utf-8",
        });
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

globalSearchService.interceptors.response.use(
  (response: any) => {
    if (response.config.responseType !== "arraybuffer") {
      if (response.status) {
        switch (response.status) {
          case 200:
            return response.data;
          case 400:
          case 401:
          case 403:
            if (response.config?.url?.indexOf(refreshURL) > -1) {
              console.log(
                "I catch err refreshURL 401/400/403 in request. will return"
              );
            }
            return;
          default:
            console.log("error", response.data.msg);
        }
      }
    } else {
      return response;
    }
  },
  (err) => {
    if (err.config?.url?.indexOf(refreshURL) > -1) {
      return;
    } else {
      switch (err.response.status) {
        case 401:
          console.log("I catch err 401. will return");
          break;
        case 403:
          break;
        case 500:
          if (localStorage.getItem(RIMS_LOCAL_STG_CONSTANTS.LOGIN_TOKEN)) {
            showMessage.error(
              i18n.t("common.tip.commonError")
              // "There is something wrong with server, please try again later"
            );
          }
          break;
        default:
      }
    }
    return Promise.reject(err);
  }
);
